import RadialChartComponent from '@/components/RadialChart';
import { ApplicationState } from '@/store';
import { MediaTypeWithConsumption } from '@/store/learningMap/types';
import { LocaleData } from '@/translations/LocaleData';
import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'underscore';
import './styles.scss';

interface LearningMapMediaTypeChartProps {
    strings: LocaleData;
    mediaTypeWithConsumption: MediaTypeWithConsumption[];
}

const LearningMapMediaTypeChart: React.FC<LearningMapMediaTypeChartProps> = ({
    strings,
    mediaTypeWithConsumption,
}: LearningMapMediaTypeChartProps) => {
    const getMediaTypeDescription = (mediaType: string): string => {
        switch (mediaType) {
            case 'VIDEO':
                return strings.VIDEO_TYPE_NAME;
            case 'AUDIO':
                return strings.AUDIO_TYPE_NAME;
            case 'HTML':
                return strings.HTML_TYPE_NAME;
            default:
                return '';
        }
    };

    const totalFinished = mediaTypeWithConsumption.reduce((sum: number, { consumedAmount }) => sum + consumedAmount, 0);

    return (
        <div className="learning-map-media-types-chart">
            <h4 className="section-title">{strings.MEDIAS}</h4>
            <div className="charts">
                {mediaTypeWithConsumption.map((media: MediaTypeWithConsumption) => {
                    return (
                        <div className="chart" key={media.mediaType}>
                            <RadialChartComponent
                                chartType="mediaChart"
                                completedItems={media.consumedAmount}
                                radius={65}
                                totalItems={totalFinished}
                            />
                            <span className="chart-label">{getMediaTypeDescription(media.mediaType)}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const LearningMapMediaTypeChartProxy: React.FC = (props: {}) => {
    const { strings, mediaTypeWithConsumption } = useSelector((state: ApplicationState) => {
        const learningMap = _.get(state.learningMap.data, 'currentLearningMap', {});
        return {
            strings: state.locale.data,
            mediaTypeWithConsumption: _.get(learningMap, 'mediaTypeWithConsumption', []) as MediaTypeWithConsumption[],
        };
    });

    return mediaTypeWithConsumption.length > 0 ? (
        <LearningMapMediaTypeChart mediaTypeWithConsumption={mediaTypeWithConsumption} strings={strings} />
    ) : null;
};

export default LearningMapMediaTypeChartProxy;
